export const English = {
  language: 'en',
  data: {
    TRANSLATOR: {
      SELECT: 'Select your language',
      ENGLISH: 'English',
      RUSSIAN: 'Russian',
    },
    MENU: {
      HOME: 'Home',
      PROFILE: 'My Profile',
      ACCOUNT: 'Account',
      SETTINGS: 'Settings',
      IDENTITY: 'Identity',
      NOTIFICATION: 'Notification',
      CONFIGURATION: 'Configuration',
      INFO: 'Info',
      TICKETS: 'Tickets',
      TITLE: 'Menu',
      ADMIN: 'Admin',
      MANAGE_COMPANIES: 'Manage Companies',
      AUDITS: 'Audits',
      MANAGE_COMPLIANCE: 'Manage Compliance',
      MANAGE_AUDIT_TYPES: 'Manage Audit Types',
      MANAGE_RULE_DATABASE: 'Manage Rule Database',
      COMPLIANCE_REPORTING: 'Compliance Reporting',
      SUPPORT: 'Support',
      DASHBOARDS: 'Dashboards',
      COMPLIANCE_VIOLATIONS_BREAKDOWN: 'Compliance Violations Breakdown',
      COMPLIANCE_VIOLATIONS_TRENDING: 'Compliance Violations Trending',
      MANAGE_USERS: 'Manage Users',
      MY_PROFILE: 'My Profile',
      MANAGE_ROLES: 'Manage Roles',
    },
    MODAL: {
      SAVE: 'Save',
      CANCEL: 'Cancel',
      YES: `Yes, I'm sure`,
      NO: 'No, cancel',
      DELETE_MESSAGE: 'Are you sure you want to delete this item',
      ADD_NEW_USER: 'Add new user',
      ADD_NEW_ROLE: 'Add new role',
      EDIT_USER: 'Edit user',
      EDIT_ROLE: 'Edit role',
      VIEW_USER: 'View user details',
      DELETE_USER: 'Delete User',
      DELETE_ROLE: 'Delete Role',
      UPDATE_USER_PASSWORD: 'Update user password',
      EDIT_GROUP: 'Edit Group',
      DELETE: 'Delete',
      EDIT_COMPANY: 'Edit Company',
      ADD_COMPANY: 'Add Company',
      ADD_RULE_DATABASE: 'Add Rule Database',
      EDIT_RULE_DATABASE: 'Edit Rule Database',
      EDIT_TYPE_PERMISSION: 'Edit Type Permission',
      ADD_TYPE_PERMISSION: 'Add Type Permission',
      ADD_RULE_AUTHORITY: 'Add Rule Authority',
      EDIT_RULE_AUTHORITY: 'Edit Rule Authority',
      ADD_RULE_FOLDER: 'Add Rule Folder',
      EDIT_RULE_FOLDER: 'Edit Rule Folder',
      ASSIGN_USER: 'Assign User',
    },
    TABLE: {
      NAME: 'Name',
      OBJECT: 'Object',
      READ: 'Read',
      WRITE: 'Write',
      CREATE: 'Create',
      DELETE: 'Delete',
      NAVIGATE: 'Navigate',
      EMAIL: 'Email',
      PHONE: 'Phone',
      MESSAGE: 'Message',
      CREATION_TIME: 'Creation Time',
      RESPONSE_TIME: 'Response Time',
      TYPE: 'Type',
      STATUS: 'Status',
      ACTIONS: 'Actions',
      NO_DATA_AVAILABLE: 'No data available',
      FIRST_NAME: 'First Name',
      LAST_NAME: 'Last Name',
      TITLE: 'Title',
      PRIMARY_COMPANY: 'Primary Company',
      USERNAME: 'User Name',
      IS_ACTIVE: 'Is Active',
      ROLE_NAME: 'Role Name',
      COMPANY_NAME: 'Company Name',
      AUDIT_COMPANY: 'Audit Company',
      BRANCH_DEPARTMENT: 'Branch Department',
      PRIMARY_CONTACT: 'Primary Contact',
      AUDIT_NAME: 'Audit Name',
      AUDIT_TYPE: 'Audit Type',
      VERSION: 'Version',
      AUDIT_STATUS: 'Audit Status',
      START_DATE: 'Start Date',
      END_DATE: 'End Date',
      ACTUAL_START_DATE: 'Actual Start Date',
      ACTUAL_END_DATE: 'Actual End Date',
      AUDITOR: 'Auditor',
      REVIEWER: 'Reviewer',
      CITY: 'City',
      STATE: 'State',
      ZIP: 'Zip',
      CURRENT_USER: 'Current User',
      BRANCH_DEPT: 'Branch Dept',
      CONTACT: 'Contact',
      CLIENT_TYPE: 'Client Type',
      FULL_COMPANY_NAME: 'Full Company Name',
      COMPANY: 'Company',
      PURCHASED_DATE: 'Purchased Date',
      COMPLIANCE_STATUS: 'Compliance Status',
      BRANCH: 'Branch',
      FULL_NAME: 'Full Name',
      ADDRESSED_VIOLATIONS_COUNT: 'Addressed Violations Count',
      PENDING_VIOLATIONS_COUNT: 'Pending Violations Count',
      VIOLATIONS_TOTAL: 'Violations Total',
      AUTHORITY_NAME: 'Authority Name',
      RULE_NUMBER: 'Rule Number',
      OUTCOME: 'Outcome',
      COMMENT: 'Comment',
      ACTIVE: 'Active',
      TYPE_PRICE: 'Type Price',
      TYPE_NAME: 'Type Name',
      DATABASE_NAME: 'Database Name',
      ORDER: 'Order',
      LETTER: 'Letter',
      DOC_ORDER: 'Doc Order',
      DOCUMENT_NAME: 'Document Name',
      PASSWORD: 'Password',
      AGREED_TO_TERMS_DATE: 'Agreed To Terms Date',
      AGREED_IP_ADDRESS: 'Agreed Ip Address',
      CHANGE_PASSWORD_ON_FIRST_LOGIN: 'Change Password On First Login',
      INDEX: 'Index',
      RULE_ORDER: 'Rule Order',
      FILE: 'File',
      NUMBER: 'Number',
      IS_CUSTOM: 'Is Custom',
      RULE: 'Rule',
      SUB_DIVISION: 'Sub Division',
      SUB_DIVISION_NAME: 'Sub Division Name',
      DIVISION: 'Division',
      DIVISION_NAME: 'Division Name',
    },
    AUDIT_TYPES: {
      TITLE: 'Audit Types',
      TYPE_NAME: 'Type Name',
      TYPE_PRICE: 'Type Price',
      ACTIVE: 'Active',
      VERSION: 'Version',
      SUMMARY: 'Summary',
      OBJECTIVES: 'Objectives',
    },
    NOTIFICATIONS: {
      TITLE: 'Notifications',
      ALERTS: 'Alerts',
      UPDATES: 'Updates',
      LOGS: 'Logs',
      VIEW_ALL: 'View all',
      UPGRADE: 'Upgrade',
      GET_PRO_ACCESS: 'Get pro access',
      ALL_ROLES: 'All Roles',
      ALL_USERS: 'All Users',
      ALL_GROUPS: 'All Groups',
      ALL_STATUSES: 'All Statuses',
      NEW_NOTIFICATION: 'New Notification',
      MARK_AS_READ: 'Mark As Read',
      SUBJECT: 'Subject',
      MESSAGE: 'Message',
      TYPE: 'Type',
      ROLE: 'Role',
      USER: 'User',
      CREATION_TIME: 'Creation Time',
      STATUS: 'Status',
      ACTION: 'Action',
      GROUP: 'Group',
      NEW_NOTIFICATIONS: {
        ROLE_ID: 'Role Id',
        USER_NAME: 'User Name',
        TITLE: 'Title',
        ALL: 'All',
      },
    },
    GROUPS: {
      TITLE: 'Groups',
      NEW_GROUP: 'New Group',
      NAME: 'Name',
      DESCRIPTION: 'Description',
      ROLES: 'Roles',
      CREATION_TIME: 'Creation Time',
      ACTION: 'Action',
    },
    IDENTITY: {
      TITLE: 'Identity',
      USERS: 'Users',
      NEW_USER: 'New User',
      NEW_ROLE: 'New Role',
      SEARCH: 'Search',
      USER_NAME: 'User name',
      FIRST_NAME: 'First Name',
      PASSWORD: 'Password',
      LAST_NAME: 'Last Name',
      EMAIL: 'Email',
      ROLE: 'Role',
      ROLE_NAME: 'Role Name ',
      ACTIONS: 'Actions',
      SHOW: 'Showing',
      TO: 'to',
      OF: 'of',
      ENTRIES: 'entries',
      DESCRIPTION: 'Description',
    },
    COMMON: {
      SEARCH: 'Search',
      PAGINATION: 'Showing {{from}} to {{to}} of {{all}} entries',
      NO_DATA_AVAILABLE_IN_TABLE: 'No data available in table',
      COPY_TO_CLIPBOARD: 'Copied to clipboard: {{value}}',
      GO_TO: 'Go to page',
      ITEMS_PER_PAGE: 'Items per page',
      NO_RECENT_ACTIVITIES: 'No recent activities',
      PROPERTY_ACTIVITY: 'Property Activity',
      ACCESS_EVENTS_OVER_TIME: 'Access events over time',
      NO_ACTIVITIES_FOUND: 'No activities found',
      RECENT_ACTIVITY: 'Recent Activity',
      PROPERTY_USAGE: 'Property Usage',
      ACCESS_FREQUENCY_BY_PROPERTY: 'Access frequency by property',
      WELCOME_BACK: 'Welcome back,',
      LAST_LOGIN: 'Last login:',
      WELCOME_TO_GATEMATE: 'Welcome to Gatemate',
      SECURITY_CENTER: 'Security Center',
      MANAGE_KEYS: 'Manage Keys',
      LIVE_VIEW: 'Live View',
      EMERGENCY: 'Emergency',
      ZONE: 'Zone',
      SELECT_OPTION: 'Select an option',
      SEARCH_RESULTS: 'Search results:',
      DEVICES: 'Devices',
      NO_DEVICES_FOUND: 'No devices found',
      GO_BACK: 'Go back',
      ACCESS_DENIED: 'Access denied',
      NOT_AUTHORIZED_TITLE: 'Oops! You are not authorized to access this page',
      NOT_AUTHORIZED_DESC: 'Sorry, but you are not authorized to access this page.',
      CREATE_INVITE_DESC: 'Create an invite to grant access to a specific apartment.',
      APARTMENT: 'Apartment',
      SELECT_APARTMENT: 'Select apartment',
      NO_APARTMENTS_FOUND: 'No apartments found',
      VALIDITY_PERIOD: 'Validity Period',
      RECEIVE_INVITE: 'Receive Invite',
      PHONE_NUMBER: 'Phone Number',
      FILTER: 'Filter',
      REVOKED: 'Revoked',
      CREATE_INVITE: 'Create Invite',
      INVITE_NOT_FOUND: 'Invite not found',
      INVITE_PROBLEM: 'There is a problem with the invite you are looking for.',
      REFRESH_OR_TRY_AGAIN: 'Please refresh the page or try again later.',
      BACK_TO_INVITES: 'Back to Invites',
      EXPIRED: 'Expired',
      VALID_FROM: 'Valid From',
      VALID_TO: 'Valid to',
      SENT_TO: 'Sent To',
      CREATED_ON: 'Created On',
      RECENT_KEY_ACTIVITY: 'Recent Key Activity',
      KEY_NOT_FOUND: 'Key not found',
      KEY_PROBLEM: 'There is a problem with the key you are looking for.',
      BACK_TO_KEYS: 'Back to Keys',
      VALIDITY: 'Validity',
      PERMANENT: 'Permanent',
      FILTERS: 'Filters',
      NO_KEYS_FOUND: 'No keys found',
      SEARCH_PROFILES_OR_APARTMENTS: 'Search for profiles or apartments',
      APARTMENTS: 'Apartments',
      PROFILES: 'Profiles',
      APARTMENT_ACCESS: 'Apartment Access',
      GRANT_ACCESS: 'Grant Access',
      SERIES: 'Series:',
      VIEW_LOGS: 'View Logs',
      REVOKE_ACCESS: 'Revoke Access',
      NO_ACCESS_KEYS: 'No Access Keys',
      NO_APARTMENT_ACCESS: "This user doesn't have access to any apartments.",
      USER_NOT_FOUND: 'User not found',
      USER_PROBLEM: 'There is a problem with the user you are looking for.',
      BACK_TO_SEARCH: 'Back to Search',
      USER_ID: 'User ID',
      ACCESS_KEYS: 'Access Keys',
      ADDED_ON: 'Added on:',
      USERS_WITH_ACCESS: 'Users with access',
      NO_USER_WITH_ACCESS: 'No user with access',
      MANAGE_ACCESS: 'Manage Access',
      VIEW: 'View',
      ONLINE: 'Online',
      OFFLINE: 'Offline',
      LOCATION: 'Location',
      LAST_ACTIVE: 'Last Active',
      LAST_SYNC: 'Last Sync',
      NEVER: 'Never',
      SYNC_MANUAL: 'Sync Manual',
      OPEN: 'Open',
      UPDATE_INVITE: 'Update Invite',
      REMOVE_INVITE: 'Remove Invite',
      ACCESS_LOGS: 'Access logs',
      ASSIGNED_TO: 'Assigned To',
      ARE_YOU_SURE_ACTION: 'Are you sure you want to proceed with this action?',
      CONFIRM: 'Confirm',
      GRANT_APARTMENT_ACCESS: 'Grant Apartment Access',
      SELECT_APARTMENT_TO_GRANT: 'Select an apartment to grant access to',
      SELECT_AN_APARTMENT: 'Select an apartment',
      NO_AVAILABLE_APARTMENTS: 'No available apartments',
      PAGE_NUMBER: 'Page number',
      GUEST: 'Guest',
      VIEW_DETAILS: 'View details',
      CLEAR: 'Clear',
      NUMBER_COLON: 'Number:',
      BACK_TO_LOGIN: 'Back to Login',
    },
    AUTH: {
      // ? ACTUAL
      TITLES: {
        LOGIN: 'Login to your account',
        REGISTER: 'Create an account',
        FORGOT: 'Forgotten Password?',
        RESET_PASSWORD: 'Reset Password',
        SESSION_EXPIRED: 'Session expired, please login again to continue',
      },
      // ? ACTUAL

      GENERAL: {
        OR: 'Or',
        SUBMIT_BUTTON: 'Submit',
        NO_ACCOUNT: "Don't have an account?",
        SIGNUP_BUTTON: 'Sign Up',
        FORGOT_BUTTON: 'Forgot Password?',
        BACK_BUTTON: 'Back',
        PRIVACY: 'Privacy',
        LEGAL: 'Legal',
        CONTACT: 'Contact',
        PLEASE_WAIT: 'Please wait',
        CONTINUE: 'Continue',
        LOG_ON: 'Log On',
      },
      LOGIN: {
        BUTTON: 'Log In',
        NEW_HERE: 'New Here',
        CONTINUE_WITH_GOOGLE: 'Continue with Google',
      },
      FORGOT: {
        DESC: 'Enter your email to reset your password',
        SUCCESS: 'Your account has been successfully reset.',
      },
      REGISTER: {
        ALREADY_HAVE_ACCOUNT: 'Already have account',
        SIGN_IN: 'Sign In',
        DESC: 'Enter your details to create your account',
        SUCCESS: 'Your account has been successfully registered.',
        AGREE: 'I agree with',
        TERMS_AND_CONDITIONS: 'terms and conditions',
        SUBMIT: 'Submit',
        CANCEL: 'Cancel',
      },
      INPUT: {
        EMAIL: 'Email',
        FULLNAME: 'Fullname',
        PASSWORD: 'Password',
        NEW_PASSWORD: 'New Password',
        CONFIRM_PASSWORD: 'Confirm Password',
        USERNAME: 'User Name',
      },
      VALIDATION: {
        INVALID: 'Field is not valid',
        REQUIRED: 'Field is required',
        PATTERN: "Field doesn't match pattern",
        MIN_LENGTH: 'Field minimum length is',
        MAX_LENGTH: 'Field maximum length is',
        AGREEMENT_REQUIRED: 'Accepting terms & conditions are required',
        NOT_FOUND: 'The requested is not found',
        INVALID_LOGIN: 'The login detail is incorrect',
        REQUIRED_FIELD: 'Required field',
        MIN_LENGTH_FIELD: 'Minimum field length:',
        MAX_LENGTH_FIELD: 'Maximum field length:',
        INVALID_FIELD: 'Field is not valid',
        MUST_MATCH: "Passwords don't match!",
      },
    },
    DASHBOARD: {
      WELCOME_MESSAGE: 'Welcome home',
      LANGUAGE: 'Language',
      SIGN_OUT: 'Sign out',
    },
    BUTTON: {
      SAVE: 'Save',
      CANCEL: 'Cancel',
      ADD: 'Add',
      ADD_ROLE: 'Add Role',
      ADD_COMPANY: 'Add Company',
      ADD_AUDIT_TYPE: 'Add Audit Type',
      CLOSE: 'Close',
      SUBMIT: 'Submit',
      ADD_RULE_DATABASE: 'Add Rule Database',
      ADD_DOCUMENT: 'Add Document',
      ADD_SECTION: 'Add Section',
      ADD_TYPE_PERMISSION: 'Add Type Permission',
      ADD_RULE_AUTHORITY: 'Add Rule Authority',
      ADD_RULE_FILE: 'Add Rule File',
      ADD_RULE_FOLDER: 'Add Rule Folder',
      ADD_RULE_LINK: 'Add Rule Link',
      EDIT_RULE_LINK: 'Edit Rule Link',
      EDIT_RULE_FOLDER: 'Edit Rule Folder',
      ADD_RULE: 'Add Rule',
      ADD_USER: 'Add User',
    },
    ACCOUNT: {
      OVERVIEW: 'Overview',
      SETTINGS: 'Settings',
      PROFILE: 'Profile',
      PROFILE_DETAILS: 'Profile details',
      FULL_NAME: 'Full name',
      FIRST_NAME: 'First name',
      LAST_NAME: 'Last name',
      CONTACT_PHONE: 'Contact phone',
      COMMUNICATION: 'Communication',
      ALLOW_CHANGES: 'Allow changes',
      LOGOUT: 'Logout',
      YES: 'Yes',
      AVATAR: 'Avatar',
      CHANGE_AVATAR: 'Change Avatar',
      CHOOSE_FILE: 'Choose File',
      VIEW_ALL_NOTIFICATIONS: 'View all notifications',
      SAVE_CHANGES: 'Save Changes',
      EDIT_PROFILE: 'Edit Profile',
      PROFILE_DETAILS_UPDATED: 'Profile details are updated!',
    },
    PROFILE: {
      INFO: {
        NOTIFICATIONS_FROM_US: 'Notifications from us',
        NOTIFICATIONS_FROM_US_DESCRIPTION: 'Receive the latest news, updates and industry tutorials from us.',
        NEWS_AND_UPDATES: 'News and updates',
        NEWS_AND_UPDATES_DESCRIPTION: 'News about product and feature updates.',
        TIPS_AND_TUTORIALS: 'Tips and tutorials',
        TIPS_AND_TUTORIALS_DESCRIPTION: 'Tips on getting more out of Untitled.',
        REMINDERS: 'Reminders',
        REMINDERS_DESCRIPTION: 'These are notifications to remind you of updates you might have missed.',
        DO_NOT_NOTIFY_ME: 'Do not notify me',
        IMPORTANT_REMINDERS_ONLY: 'Important reminders only',
        IMPORTANT_REMINDERS_ONLY_DESCRIPTION: 'Only notify me if the reminder is tagged as important.',
        ALL_REMINDERS: 'All Reminders',
        ALL_REMINDERS_DESCRIPTION: 'Notify me for all reminders.',
        MORE_ACTIVITY_ABOUT_YOU: 'More activity about you',
        MORE_ACTIVITY_ABOUT_YOU_DESCRIPTION: 'These are notifications for posts on your profile, likes and other reactions to your posts.',
        UNSUBSCRIBE: 'Unsubscribe',
        UNSUBSCRIBE_DESCRIPTION: 'You will no longer receive notifications from us.',
        SUBSCRIBE: 'Subscribe',
        SUBSCRIBE_DESCRIPTION: 'You will receive notifications from us.',
        TITLE: 'Profile',
        USER_NAME: 'Username',
        ROLE: 'Role',
        FIRST_NAME: 'First Name',
        LAST_NAME: 'Last Name',
        CITY: 'City',
        STATE: 'State',
        ZIP: 'Zip',
        ADDRESS: 'Address',
        PHONE: 'Phone',
        NOTIFICATIONS: 'Notifications',
        TIMEZONE: 'Timezone',
        PASSWORD: 'Password',
        NEW_PASSWORD: 'New Password',
        EMAIL: 'Email',
        CONFIRM_NEW_PASSWORD: 'Confirm new password',
      },
      FORM: {
        PASSWORD_TITLE: 'Password',
        PASSWORD_DESC: 'Update your password here.',
        CURRENT_PASSWORD: 'Current Password',
        NEW_PASSWORD: 'New Password',
        CONFIRM_NEW_PASSWORD: 'Confirm New Password',
        CANCEL: 'Cancel',
        SAVE: 'Save',
      },
    },
    ADMINISTRATION: {
      MANAGE_USERS: {
        TITLE: 'Manage Users',
        NEW_USER: 'Add User',
        FIRST_NAME: 'First Name',
        LAST_NAME: 'Last Name',
        EMAIL: 'Email',
        PRIMARY_COMPANY: 'Primary Company',
        USERNAME: 'Username',
        AGREED_TO_TERMS: 'Agreed to terms Date',
        IS_ACTIVE: 'Is Active',
        USER_TITLE: 'Title',
      },
      MANAGE_ROLES: {
        TITLE: 'Manage Roles',
        NAME: 'Name',
        IS_ADMINISTRATIVE: 'Is Administrative',
        ADD_ROLE: 'Add Role',
        EDIT_ROLE: 'Edit Role',
      },
    },
    COMPLIANCE_VIOLATIONS_BREAKDOWN: {
      TITLE: 'Compliance Violations Breakdown',
      COMPANY: 'Company',
      BRANCH_DEPT: 'Branch Dept',
      AUDIT_TYPE: 'Audit Type',
      AUDIT_NAME: 'Audit Name',
      YEAR: 'Year',
      VIOLATIONS_BREAKDOWN: 'Violations Breakdown',
    },
    COMPLIANCE_VIOLATIONS_TRENDING: {
      TITLE: 'Compliance Violations Trending',
      COMPANY: 'Company',
      BRANCH_DEPT: 'Branch Dept',
      AUDIT_TYPE: 'Audit Type',
      AUDIT_NAME: 'Audit Name',
      YEAR: 'Year',
      VIOLATIONS_TRENDING_ANALYSIS: 'Violations Trending Analysis',
      VIOLATIONS_TRENDING_ANALYSIS_GRID: 'Violations Trending Analysis (Grid)',
    },
    COMPLIANCE: {
      TITLE: 'Compliance',
    },
    SUPPORT: {
      TITLE: 'Support',
      RESOURCES: 'Resources',
      CONTACT_US: 'Contact Us',
      SALES: 'Sales',
    },
    TYPE_PERMISSION: {
      TARGET_TYPE: 'Target Type',
      CREATE: 'Create',
      READ: 'Read',
      WRITE: 'Write',
      DELETE: 'Delete',
      NAVIGATE: 'Navigate',
    },
    AUDITS: {
      TITLE: 'Audits',
      NAME: 'Audit Name',
      COMPANY: 'Company',
      AUDIT_TYPE: 'Audit Type',
      AUDIT_STATUS: 'Audit Status',
      AUDITOR: 'Auditor',
      REVIEWER: 'Reviewer',
      COMPLIANCE: 'Compliance',
      START_DATE: 'Start Date',
      END_DATE: 'End Date',
      ACTUAL_START_DATE: 'Actual Start Date',
      ACTUAL_END_DATE: 'Actual End Date',
      RECIPIENT: 'Recipient',
      ADDRESS: 'Address',
      CITY: 'City',
      STATE: 'State',
      ZIP: 'Zip',
    },
    COMPLIANCE_ANALYSIS: {
      TITLE: 'Compliance Analysis',
    },
    MANAGE_COMPANIES: {
      TITLE: 'Manage Companies',
      COMPANY_NAME: 'Company Name',
      AUDIT_COMPANY: 'Audit Company',
      BRANCH_DEPARTMENT: 'Branch Department',
      CLIENT_TYPE: 'Client Type',
      PRIMARY_CONTACT: 'Primary Contact',
      ADDRESS: 'Address',
      CITY: 'City',
      STATE: 'State',
      ZIP_CODE: 'Zip Code',
      PHONE: 'Phone',
      WEBSITE: 'Website',
      TYPE: 'Type',
    },
    MANAGE_RULE_DATABASE: {
      TITLE: 'Manage Rule Database',
      NAME: 'Rule Database Name',
      IS_ACTIVE: 'Is Active',
      VERSION: 'Version',
      ORDER: 'Order',
      AUTHORITY_NAME: 'Authority Name',
    },
    RULE_LINK: {
      TITLE: 'Rule Link',
      IS_ACTIVE: 'Is Active',
      RULE_TITLE: 'Title',
      ORDER: 'Order',
      FILE: 'File',
      NUMBER: 'Number',
      HYPER_LINK: 'Hyper Link',
      DISPLAY_TEXT: 'Display Text',
    },
    RULE_FOLDER: {
      RULE: 'Rule',
      SECTION: 'Section',
      SUB_SECTION: 'Sub Section',
      SECTION_TITLE: 'Section Title',
      SUB_SECTION_TITLE: 'Sub Section Title',
      IS_ACTIVE: 'Is Active',
    },
    TICKETS: { TITLE: 'Tickets' },
    SIGN_IN_METHOD: {
      TITLE: 'Sign-In Method',
      EMAIL_ADDRESS: 'Email Address',
      CHANGE_EMAIL: 'Change Email',
      PASSWORD: 'Password',
      CURRENT_PASSWORD: 'Current Password',
      NEW_PASSWORD: 'New Password',
      CONFIRM_CURRENT_PASSWORD: 'Confirm New Password',
      RESET_PASSWORD: 'Reset password',
      ENTER_NEW_EMAIL_ADDRESS: 'Enter new email address',
      UPDATE_EMAIL: 'Update Email',
      UPDATE_PASSWORD: 'Update password',
      CANCEL: 'Cancel',
      PASSWORD_WAS_UPDATED: 'Password has been updated successfully',
      INCORRECT_PASSWORD: 'Incorrect password',
      PASSWORD_RULE: 'Password must be at least 6 character and contain symbols',
      VALIDATION: {
        CURRENT_PASS_REQUIRED: 'Current password is required!',
        CURRENT_PASS_MIN: 'Current password should have at least 6 symbols',
        CURRENT_PASS_MAX: 'Current password should have maximum 25 symbols',
        NEW_PASS_REQUIRED: 'New password is required!',
        NEW_PASS_MIN: 'New password should have at least 6 symbols',
        NEW_PASS_MAX: 'New password should have maximum 25 symbols',
        CONFIRM_PASS_REQUIRED: 'Current password is required!',
        PASS_DO_NOT_MATCH: "Passwords don't match!",
      },
    },
    FOOTER: {
      POWERED_BY: 'Powered by',
      RIGHTS: 'All rights reserved',
      COPYRIGHT: 'Copyright',
    },
    MODE: {
      DARK: 'Dark mode',
      LIGHT: 'Light mode',
    },

    HEADER: {
      PHONE: '1 123 456 7890',
    },
    ERROR: {
      ERROR: '404',
      TITLE: 'Oops! Page not found',
      DESCRIPTION: 'Sorry, but the page you are trying to access \n does not exist or has been removed.',
    },
  },
};
